export const BUILT_IN_MATERIAL_TYPES = [
  'S10C, S15C',
  'S25C, S30C',
  'S45C, S48C',
  'S55C, S58C',
  'SS330, SS440',
  'SCM, SNCM, SCR415',
  'SCM, SNCM, SCR420',
  'SCM, SNCM, SCR430',
  'SCM, SNCM, SCR440',
  'SUS304, SUS316',
  'Other_1',
  'Other_2',
].map((label, index) => ({
  code: index + 1,
  label,
  active: true,
  displayOrder: index + 1,
  builtIn: true,
}));

export const effectiveMaterialTypes = (stored = []) => {
  const byCode = new Map(BUILT_IN_MATERIAL_TYPES.map((material) => [material.code, { ...material }]));
  stored.forEach((material) => {
    const code = Number(material.code);
    if (!Number.isInteger(code) || code <= 0) return;
    byCode.set(code, {
      ...material,
      code,
      builtIn: byCode.has(code) && code <= 12,
    });
  });
  return Array.from(byCode.values()).sort((left, right) => (
    Number(left.displayOrder) - Number(right.displayOrder) || left.code - right.code
  ));
};

const numericCode = (value) => {
  if (typeof value === 'number' && Number.isInteger(value) && value >= 0) return value;
  if (typeof value === 'string' && /^\d+$/.test(value.trim())) return Number(value.trim());
  return null;
};

export const resolveMaterialType = (value, definitions = [], legacyLabel = '', allowBuiltInFallback = true) => {
  const code = numericCode(value);
  if (code !== null) {
    const tenantDefinition = definitions.find((material) => Number(material.code) === code);
    if (tenantDefinition?.label) return tenantDefinition.label;
    const builtIn = allowBuiltInFallback && BUILT_IN_MATERIAL_TYPES.find((material) => material.code === code);
    if (builtIn) return builtIn.label;
    return `Unknown(${code})`;
  }
  const historical = String(value ?? legacyLabel ?? '').trim();
  return historical || '-';
};
